import React, { useEffect, useState, useContext, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import Image from '../common/image';
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import { ToastContainer, toast } from 'react-toastify';

import ConfirmationPopup from '../common/ConfirmationPopup ';
import CustomDropdown from '../common/CustomDropdown';
import axios from 'axios';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';

function LocMasterList() {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);

    // State variables
    const [userData, setUserdata] = useState([]); // User data fetched from the server
    const [message, setMessage] = useState(''); // Message to display to the user
    const [firstFilter, setFirstFilter] = useState(''); // First filter selection
    const [firstFilterSearch, setFirstFilterSearch] = useState(''); // First filter search input
    const [secondFilter, setSecondFilter] = useState(''); // Second filter selection
    const [secondFilterSearch, setSecondFilterSearch] = useState(''); // Second filter search input
    const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
    const [itemsPerPage, setItemsPerPage] = useState(10); // Number of items per page
    const [statusFilter, setStatusFilter] = useState(''); // Status filter selection
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false); // Control the visibility of the confirmation popup
    const [suspendId, setSuspendId] = useState(null); // ID of the item to suspend
    const [firstFilterOptions, setFirstFilterOptions] = useState([
        { value: 'LCM_LocationName', label: 'Location Name', disabled: false },
        { value: 'LCM_LocationCode', label: 'Location Code', disabled: false },
        { value: 'LCM_Type', label: 'Location Type', disabled: false },
        ...(parseInt(UM_UserType) === 1 ? [{ value: 'SCPM_Name', label: 'SCP Name', disabled: false }] : []),
        { value: 'LCM_GLN', label: 'GLN', disabled: false },
        { value: 'LCM_SGLN', label: 'SGLN', disabled: false },
    ]);
    const [secondFilterOptions, setSecondFilterOptions] = useState([
        { value: 'LCM_LocationName', label: 'Location Name', disabled: false },
        { value: 'LCM_LocationCode', label: 'Location Code', disabled: false },
        { value: 'LCM_Type', label: 'Location Type', disabled: false },
        ...(parseInt(UM_UserType) === 1 ? [{ value: 'SCPM_Name', label: 'SCP Name', disabled: false }] : []),
        { value: 'LCM_GLN', label: 'GLN', disabled: false },
        { value: 'LCM_SGLN', label: 'SGLN', disabled: false },
    ]);
    const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('UM_UserType', UM_UserType);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);
    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const currentTimestamp = getCurrentTimestamp();
        const AUTR_OldValue = details?.AUTR_OldValue ?? null;
        const AUTR_NewValue = details?.AUTR_NewValue ?? null;
        const AUTR_Message = details.AUTR_Message;
        const AUTR_AuditType = details.AUTR_AuditType;

        const data = {
            AUTR_ScreenName: "Location Master",
            AUTR_OldValue: AUTR_OldValue,
            AUTR_NewValue: AUTR_NewValue,
            AUTR_Message: AUTR_Message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_TimeStamp: currentTimestamp,
            AUTR_AuditType: AUTR_AuditType,
            AUTR_SCPID: selectedScpId,
            AUTR_CompanyGrpId: UM_CompanyGrpID,
            AUTR_CompanyID: UM_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            AUTR_CreatedDateTime: currentTimestamp
        };

        try {
            const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
            console.log('Success:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error:', error);
        }
    };
    useEffect(() => {
        setCurrentPage(1);
    }, [firstFilterSearch, secondFilterSearch, statusFilter]);
    const logAction = async (action, isError = false) => {
        console.log(`${isError ? '[ERROR] ' : ''}${action}`);
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Location Master:", action, userCode: UM_UserCode, isError }),
            });
            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };
    //TILL HERE

    useEffect(() => {
        const getUserdata = async () => {
            // Determine which ID to send based on user type
            const paramId = parseInt(UM_UserType) === 1 ? UM_CompanyID : selectedScpId;
            try {
                const reqData = await fetch(`${config.API_URL}/LocationMaster/${paramId}?userType=${UM_UserType}`, {
                    method: 'GET',
                });
                if (reqData.ok) {
                    const resData = await reqData.json();
                    console.log('List of companies', resData);
                    setUserdata(resData)
                    logAction('getUserdata():succefully recived the data from location master table ', true)
                } else {
                    console.error('Error fetching the company list')
                }
            } catch (error) {
                console.log("Failed to fetch data:", error);
                setMessage("please check Data");
                logAction('getUserdata():Failed to fetch data', true)
            }
        };
        getUserdata();
    }, []);

    const handleSuspendWithConfirmation = (SCPM_ID) => {
        setSuspendId(SCPM_ID);
        setShowConfirmationPopup(true);
    };


    const confirmSuspend = async (LCM_ID, LCM_Remarks) => {
        console.log("Suspend ID:", LCM_ID);
        console.log("Suspend Remark:", LCM_Remarks);

        try {
            const response = await fetch(`${config.API_URL}/LocationMaster/Suspend/${LCM_ID}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ LCM_Status: 3, LCM_Remarks }) // Sending LCM_Status & LCM_Remarks
            });

            if (response.ok) {

                const updatedUserData = userData.map(item =>
                    item.LCM_ID === LCM_ID ? { ...item, LCM_Status: 3, LCM_Remarks } : item
                );
                setUserdata(updatedUserData);

                const SuspendLocation = updatedUserData.find(item => item.LCM_ID === LCM_ID)?.LCM_LocationName;

                const details = {
                    AUTR_Message: `${SuspendLocation} Suspend`,
                    AUTR_AuditType: "Suspend",
                };
                let id = await audittrailpost(details);

                const details1 = {
                    AUTRN_ParamererName: "Status",
                    AUTRN_NewValue: "Suspend",
                    AUTRN_ID: id,
                    AUTRN_OldValue: suspendId.LCM_Status === 1 ? "Active" :
                        suspendId.LCM_Status === 2 ? "Inactive" : "Unknown"
                };
                audittransection(details1);

                if (SuspendLocation) {
                    showToast('success', `Location : ${SuspendLocation} suspended successfully.`);
                }
                logAction("handleSuspend(): Location Master suspended successfully.");
            } else {
                const errorData = await response.json();
                showToast('error', "Location could not be suspended successfully");
                console.error('Error suspending Location Master:', errorData.error);
                logAction("handleSuspend(): Error in Location Master Suspend", true);
            }
        } catch (err) {
            console.log('Network error:', err);
            showToast('error', "Location could not be suspended successfully");
            logAction('handleConfirmStatusChange(): Failed to update status or Network error:', true);
        }
        setShowConfirmationPopup(false);
    };

    const handleFirstFilterChange = (event) => {
        const value = event.target.value;
        setFirstFilter(value);
        setFirstFilterSearch('');
        const updatedSecondOptions = secondFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setSecondFilterOptions(updatedSecondOptions);
    };
    const handleSecondFilterChange = (event) => {
        const value = event.target.value;
        setSecondFilter(value);
        setSecondFilterSearch('');
        const updatedFirstOptions = firstFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setFirstFilterOptions(updatedFirstOptions);
    };

    const handleStatusFilterChange = (event) => {
        const value = event.target.value;
        logAction("handleStatusFilterChange(): Status is changed in the dropdown");
        setStatusFilter(value);
        logAction("handleStatusFilterChange(): Data filtered according to the selected status");
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 1:
                return 'Active';
            case 2:
                return 'Inactive';
            case 3:
                return 'Suspend';
            default:
                return '';
        }
    };

    const filteredListData = userData.filter(item => {
        const firstFilterValue = item[firstFilter];
        const secondFilterValue = item[secondFilter];
        const statusValue = getStatusLabel(item.LCM_Status);
        const containsActive = /act(ive)?/i.test(firstFilterSearch);
        const containsInactive = /inact(ive)?/i.test(firstFilterSearch);
        const matchesFirstFilter =
            (!firstFilter || !firstFilterSearch) ||
            (firstFilter === 'LCM_Status' &&
                (
                    (containsActive && firstFilterValue === 1) ||
                    (containsInactive && firstFilterValue === 2)
                )
            ) ||
            (firstFilter !== 'LCM_Status' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));
        const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
        const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);
        const matchesSecondFilter =
            (!secondFilter || !secondFilterSearch) ||
            (secondFilter === 'LCM_Status' &&
                (
                    (containsActive2 && secondFilterValue === 1) ||
                    (containsInactive2 && secondFilterValue === 2)
                )
            ) ||
            (secondFilter !== 'LCM_Status' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));
        const matchesStatusFilter = !statusFilter || statusValue === statusFilter;
        return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    });
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const audittransection = async (data) => {
        const formData = {
            AUTRN_ID: data.AUTRN_ID,
            AUTRN_OldValue: data.AUTRN_OldValue ?? null,
            AUTRN_NewValue: data.AUTRN_NewValue,
            AUTRN_ParamererName: data.AUTRN_ParamererName
        };
        console.log(formData)
        try {
            const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error setting up the request:', error.message);
            }
        }
    }
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };
    //==================================
    return (
        <React.Fragment>
                    <ToastContainer style={{ marginTop: '73px', fontSize: '14px', width: '40%' }} />
            
            <div className='main_container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h4 className='formHeading' >Location Master </h4>
                        <p>{message}</p>
                        <div className="filter-container">
                            <div className='select-container_list'>
                                <CustomDropdown
                                    options={firstFilterOptions}
                                    value={firstFilter}
                                    onChange={handleFirstFilterChange}
                                    name="firstFilter"
                                    placeholder="--Select--"
                                    idKey="value"
                                    displayKey="label"
                                    onMenuOpen={() => handleSelectOpen('firstFilter')}
                                    onMenuClose={handleSelectClose}
                                />

                            </div>
                            <input type="text"
                                className='search-input'
                                value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />
                            <div className='select-container_list'>
                                <CustomDropdown
                                    options={secondFilterOptions}
                                    value={secondFilter}
                                    onChange={handleSecondFilterChange}
                                    name="secondFilter"
                                    placeholder="--Select--"
                                    idKey="value"
                                    displayKey="label"
                                    onMenuOpen={() => handleSelectOpen('secondFilter')}
                                    onMenuClose={handleSelectClose}
                                />
                            </div>
                            <input type="text"
                                className='search-input'
                                value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder='Search' />
                            <div className='select-container_list'>
                                <CustomDropdown
                                    options={[
                                        { value: 'Active', label: 'Active' },
                                        { value: 'Inactive', label: 'Inactive' },
                                        { value: 'Suspend', label: 'Suspend' }
                                    ]}
                                    value={statusFilter}
                                    onChange={handleStatusFilterChange}
                                    name="statusFilter"
                                    placeholder="--Select Status--"
                                    idKey="value"
                                    displayKey="label"
                                    onMenuOpen={() => handleSelectOpen('statusFilter')}
                                    onMenuClose={handleSelectClose}
                                />

                            </div>
                        </div>
                        <div className="ptable-wrapper">
                            <table className="ptableClass">
                                <thead >
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th className='nav-tabs'>Location Name</th>
                                        <th className='nav-tabs'>Location Code</th>
                                        <th className='nav-tabs'>Location Type</th>
                                        {parseInt(UM_UserType) === 1 && (
                                            <th className='nav-tabs'>SCP Name</th>
                                        )}
                                        <th className='nav-tabs'>GLN</th>
                                        <th className='nav-tabs'>SGLN</th>
                                        <th className='nav-tabs' style={{width: "68px"}}>Status</th>
                                        <th className='nav-tabs'>Action</th>
                                    </tr>
                                </thead>
                                {filteredListData.length === 0 ? (
                                    <tbody >
                                        <tr>
                                            <td colSpan="10">No Records Found</td> {/* Set colSpan to match the number of columns */}
                                        </tr>
                                    </tbody>
                                ) : (
                                    <tbody>
                                        {currentItems.map((userData, index) => (
                                            <tr key={index}>
                                                <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                                <td>{userData.LCM_LocationName}</td>
                                                <td>{userData.LCM_LocationCode}</td>
                                                <td>{userData.LCM_Type}</td>
                                                {parseInt(UM_UserType) === 1 && (
                                                    <td>{userData.SCPM_Name}</td>
                                                )}
                                                <td>{userData.LCM_GLN}</td>
                                                <td>{userData.LCM_SGLN}</td>
                                                <td style={{width: "68px"}}> 
                                                    {userData.LCM_Status === 1 && "Active"}
                                                    {userData.LCM_Status === 2 && "Inactive"}
                                                    {userData.LCM_Status === 3 && "Suspend"}
                                                </td>
                                                <td>
                                                    {userData.LCM_Status !== 3 ? ( // Check if status is not already 3
                                                        <>
                                                            <Link to={`/dashboard/Locationmasteredit/${userData.LCM_ID}`} type='button' title='Edit' className='' > <Image

                                                                src={Icon3}
                                                                alt="pencil"
                                                                className="editicon"
                                                                width={25} />
                                                            </Link>

                                                            <img
                                                                src={Icon4}
                                                                alt="suspendremovebg"
                                                                className=""
                                                                title='Suspend'
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleSuspendWithConfirmation(userData)}
                                                            />
                                                        </>
                                                    ) : (
                                                        <span>-</span> // Display N/A if already suspended
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
                <ul className="pagination">
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>
                    {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>

            </div>
            {showConfirmationPopup && suspendId && (
                <ConfirmationPopup
                    message={`Are you sure you want to suspend this Location : ${suspendId.LCM_LocationName} ?`}
                    onCancel={() => setShowConfirmationPopup(false)}
                    onConfirm={(remark) => confirmSuspend(suspendId.LCM_ID, remark)}
                />
            )}
            <Link to={`/dashboard/LocationMaster`} type='button' className='back_btn' > BACK </Link>

        </React.Fragment>
    )
}
export default LocMasterList;

